const settingsBasePath = '/settings';

const translationAiStaticLanguages = [
    {
        slug: 'en',
        label: 'English',
        short: 'EN',
    },
    {
        slug: 'de',
        label: 'Deutsch',
        short: 'DE',
    },
];

const translationAiRuntimeLanguages = [
    { slug: 'pl', label: 'Polish', short: 'PL' },
    { slug: 'cs', label: 'Czech', short: 'CS' },
    { slug: 'sk', label: 'Slovak', short: 'SK' },
    { slug: 'hu', label: 'Hungarian', short: 'HU' },
    { slug: 'ro', label: 'Romanian', short: 'RO' },
    { slug: 'bg', label: 'Bulgarian', short: 'BG' },
    { slug: 'sr', label: 'Serbian', short: 'SR' },
    { slug: 'hr', label: 'Croatian', short: 'HR' },
    { slug: 'bs', label: 'Bosnian', short: 'BS' },
    { slug: 'sl', label: 'Slovenian', short: 'SL' },
    { slug: 'mk', label: 'Macedonian', short: 'MK' },
    { slug: 'sq', label: 'Albanian', short: 'SQ' },
    { slug: 'uk', label: 'Ukrainian', short: 'UK' },
];

const translationAiLanguageCacheStatus = {
    static       : 'static',
    ready        : 'ready_from_cache',
    loaded       : 'loaded',
    notRequested : 'not_requested',
};

const SettingsConst = {
    basePath: settingsBasePath,
    translationAiUsagePath: `${ settingsBasePath }/translation-ai-usage`,
    translationAiRequestsPath: `${ settingsBasePath }/translation-ai-requests`,
    translationAiStaticLanguages,
    translationAiRuntimeLanguages,
    translationAiLanguages: [
        ...translationAiStaticLanguages,
        ...translationAiRuntimeLanguages,
    ],
    translationAiLanguageCacheStatus,
};

export default SettingsConst;
